export enum DashboardType {
    TIER_ONE = 1,
    TIER_TWO,
    TIER_THREE,
}

export class ChatRatingModel {
    constructor() { }
    TotalReviews: number;
    AvgRating: number;
    OneStar: number;
    TwoStar: number;
    ThreeStar: number;
    FourStar: number;
    FiveStar: number;
}

export class OnboardingDetailsModel {
    constructor() { }
    OnboardingStatus: boolean;
    CheckPoints: { Title: string, Status: boolean }[]
}


export const mapToChatRatingModel = (x: any): ChatRatingModel => {
    return {
        TotalReviews: x.total_ratings,
        AvgRating: x.avg_rating,
        OneStar: x.star_rating.one_star,
        TwoStar: x.star_rating.two_star,
        ThreeStar: x.star_rating.three_star,
        FourStar: x.star_rating.four_star,
        FiveStar: x.star_rating.five_star,
    } as ChatRatingModel;
}

export const mapToOnboardingDetailsModel = (x: any): OnboardingDetailsModel => {
    return {
        OnboardingStatus: x.onboardingStatus,
        CheckPoints: x.checkpoints?.map(y => { return { Title: y.title, Status: y.status } }) || []
    } as OnboardingDetailsModel
}